import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Flex, H5, M } from 'design-system-web';
import { CreateCoverageHoursPanel } from './CreateCoverageHoursPanel';
import styles from './CoverageHours.scss';

export function CoverageHours() {
  const { t } = useTranslation();
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  return (
    <Flex direction="column" gap={6} className={styles.coverageHoursTab}>
      <div className={styles.sectionIntro}>
        <H5 className={styles.sectionTitle}>
          {t('web.admin.serviceRequest.settings.tabs.coverageHours')}
        </H5>
        <M className={styles.sectionDescription}>
          {t('web.admin.serviceRequest.settings.coverageHours.description')}
        </M>
      </div>
      <div className={styles.toolbar}>
        <Button
          variant="primary"
          size="large"
          testId="coverage-hours-create"
          onClick={() => setIsPanelOpen(true)}
        >
          {t(
            'web.admin.serviceRequest.settings.coverageHours.create.button'
          )}
        </Button>
      </div>

      <CreateCoverageHoursPanel
        isOpen={isPanelOpen}
        onClose={() => setIsPanelOpen(false)}
      />
    </Flex>
  );
}
